import React from 'react';
import { memo } from 'react';

import { FrameContainer, StyledImage } from './Frame.style';

interface FrameProps {
  dicom: any;
  frame: any;
  isActive: boolean;
  scale: number;
}

const Frame = ({ dicom, frame, isActive, scale }: FrameProps) => {
  return (
    <FrameContainer isActive={isActive} scale={scale}>
      <StyledImage
        src={frame?.file}
        style={{
          height: dicom?.pixelHeight,
          width: dicom?.pixelWidth,
        }}
        loading="eager"
      />
    </FrameContainer>
  );
};

export default memo(Frame);
